import { Users } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

interface ProfileHeaderStatsProps {
  profileId: string;
  onFollowersClick: () => void;
  onFollowingClick: () => void;
}

export const ProfileHeaderStats = ({ profileId, onFollowersClick, onFollowingClick }: ProfileHeaderStatsProps) => {
  const { data: followersCount = 0 } = useQuery({
    queryKey: ['followers-count', profileId],
    queryFn: async () => {
      if (!profileId) return 0;
      const { count, error } = await supabase
        .from('user_follows')
        .select('*', { count: 'exact', head: true })
        .eq('following_id', profileId);

      if (error) throw error;
      return count || 0;
    },
    enabled: !!profileId,
  });

  const { data: followingCount = 0 } = useQuery({
    queryKey: ['following-count', profileId],
    queryFn: async () => {
      if (!profileId) return 0;
      const { count, error } = await supabase
        .from('user_follows')
        .select('*', { count: 'exact', head: true })
        .eq('follower_id', profileId);

      if (error) throw error;
      return count || 0;
    },
    enabled: !!profileId,
  });

  return (
    <div className="flex gap-4 mt-4 text-gray-400">
      <button 
        onClick={onFollowersClick}
        className="flex items-center gap-2 hover:text-flux-cyan transition-colors"
      >
        <Users size={16} />
        {followersCount} followers
      </button>
      <span>•</span>
      <button
        onClick={onFollowingClick}
        className="hover:text-flux-cyan transition-colors"
      >
        {followingCount} following
      </button>
    </div>
  );
};